import { PencilOffOutlineIcon } from './PencilOffOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 5B4952DA-7867-403A-AC98-12CFA78B52C0
 * name pencil-off-outline
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil-off-outline.svg
 * tags
 */
export const EditOffOutlineIcon = PencilOffOutlineIcon;
export default EditOffOutlineIcon